import { Icon, Typography } from "@/components/atoms";
import { VeivoVehicleSummary } from "@/redux/apis/vehicle/veivoApi";

/** "Toyota Kluger GXL" — what Find (or the documents) say the car is. */
export const vehicleTitle = (vehicle: Pick<VeivoVehicleSummary, "make" | "model"> | null | undefined, fallback = "Vehicle") =>
  [vehicle?.make, vehicle?.model].filter(Boolean).join(" ") || fallback;

/** The car, named, on a grey card — Find, the finish-later modal, the drafts. */
export const VehicleCard = ({ title, subtitle, photoUrl }: { title: string; subtitle?: string; photoUrl?: string | null }) => (
  <div className="flex items-center gap-3 rounded-lg bg-neutral-surface-gray p-3">
    <span className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white text-neutral-dark-gray">
      {photoUrl ? <img src={photoUrl} alt="" className="h-full w-full object-cover" /> : <Icon name="Car" size="md" />}
    </span>
    <div className="min-w-0">
      <Typography variant="action" className="block truncate text-neutral-black">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          {subtitle}
        </Typography>
      )}
    </div>
  </div>
);
